import { Pipe } from 'angular2/core';

@Pipe({
    name: 'nl2p',
    pure: false,
})
export class Nl2pPipe {

	public transform(text: string, args: any[]): any {
    let ps = text.split('\n').filter(str => { return (str !== ''); });
    return '<p>' + ps.join('</p><p>') + '</p>';
	}
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/strings/nltop-pipe.ts
 **/